<template lang="pug">
	v-alert.flow-left(border="left" colored-border type="info" color="accent" elevation="0")
		.font-weight-bold Informatie: Onderhoud Kortlopende reisverzekering
		p Vanwege de overgang naar een nieuw administratiesysteem kunnen momenteel geen online aanvragen, wijzigingen en/of schademeldingen verwerkt worden.
		p Bekijk <a href="/weblog/bericht/511988/veelgestelde-vragen-over-het-corona-virus-en-de-reisverzekering">hier</a> de meestgestelde vragen over uw reisverzekering en corona.
		p Voor nieuwe verzekeringsaanvragen of wijzigingen kan contact opgenomen worden met de afdeling ledenservice per telefoon 030 – 3077812 of mail verzekeren@wintersport.nl.
		p Schademelden kan door het pdf-schadeformulier in te vullen en per mail te sturen naar verzekeren@wintersport.nl. Excuses voor het ongemak.
		v-alert(text color="accent")
			.font-weight-bold Contact ledenservice:
			ul
				li
					a.external(href="tel:+31303077812" target="_blank" rel="nofollow") +31 (0)30 30 77 812
				li
					a.external(href="mailto:verzekeren@wintersport.nl" target="_blank" rel="nofollow") verzekeren@wintersport.nl
			small Bereikbaar op werkdagen tussen 09:00 en 17:00 uur
		v-alert(text color="accent")
			.font-weight-bold Schade melden:
			ul
				li
					a.external(href="https://download.wintersport.nl/media/downloads/2021/11/25/schadeformulier-reisverzekering-2019-25-11-2021.pdf" target="_blank" rel="nofollow") Download schadeformulier reisverzekering (pdf)
				li
					a.external(href="https://download.wintersport.nl/media/downloads/2021/11/25/schadeformulier-annulering-2019-25-11-2021.pdf" target="_blank" rel="nofollow") Download schadeformulier annulering (pdf)
			small Versturen naar verzekeren@wintersport.nl
</template>

<script>
export default {
	name: 'MaintenanceBox'
};
</script>
